import { ReactNode } from 'react'
import '../sidebar.css'
import SidebarMenu from './SidebarMenu'
import { useApp } from 'providers/AppProvider'
import ErrorView from 'views/ErrorView'
import menuLeft from 'images/menu-left.svg'
import menuRight from 'images/menu-right.svg'
import Spinner from 'views/Spinner'
import { Role, useCompositeAuth } from 'providers/CompositeAuthProvider'

interface Props {
  children: ReactNode
}

export default function SidebarLayout({ children }: Props): JSX.Element {
  const { isLoading, isAuthenticated, getRole } = useCompositeAuth()
  const { isMinimized, setIsMinimized } = useApp()

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized)
  }

  const getMenuButtonStyle = () => {
    return isMinimized
      ? 'sidebar-button-right ml-[14px]'
      : 'sidebar-button-left'
  }

  const getMenuButtonImage = () => {
    return isMinimized ? menuRight : menuLeft
  }

  const getMenuStyle = () => {
    return isMinimized ? 'sidebar-menu-minimized' : 'sidebar-menu'
  }

  const getContentStyle = () => {
    return isMinimized ? 'sidebar-content-minimized' : 'sidebar-content'
  }

  return (
    <div className="sidebar-container">
      <div className={getMenuStyle()}>
        <SidebarMenu isMinimized={isMinimized} />
      </div>
      <div className={getContentStyle()}>
        {isLoading && <Spinner />}
        {isAuthenticated && !isLoading && getRole() === Role.None && (
          <ErrorView />
        )}
        {isAuthenticated && !isLoading && getRole() !== Role.None && children}
      </div>
      <div className={getMenuButtonStyle()}>
        <button onClick={toggleMinimize}>
          <img src={getMenuButtonImage()} alt="menu-button" />
        </button>
      </div>
    </div>
  )
}
